/**
 * Validates a slug string according to the application's rules
 * @param value The slug string to validate
 * @returns An error message if validation fails, or an empty string if validation passes
 */
export const validateSlug = (value: string): string => {
  if (!value) return '';

  const validation = /^[a-z0-9](?:[-_]?[a-z0-9])*$/;

  if (!validation.test(value)) {
    return 'Le slug doit commencer par une lettre ou un chiffre et ne peut contenir que des lettres minuscules, chiffres, tirets et underscores';
  }

  return '';
};
